import { render, staticRenderFns } from "./editVehicleStaff.vue?vue&type=template&id=7f967d40"
import script from "./editVehicleStaff.vue?vue&type=script&lang=js"
export * from "./editVehicleStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports